import { render, staticRenderFns } from "./SalaryCommunicationItem.vue?vue&type=template&id=af87478c&scoped=true&"
import script from "./SalaryCommunicationItem.vue?vue&type=script&lang=js&"
export * from "./SalaryCommunicationItem.vue?vue&type=script&lang=js&"
import style0 from "./SalaryCommunicationItem.vue?vue&type=style&index=0&id=af87478c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af87478c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VForm,VRow})
